import React from 'react';
import type { Section } from '../types/article';
import { ArticleFigure } from './ArticleFigure';
import { Prose } from './Prose';
interface ArticleSectionProps {
  section: Section;
  /** Renders the eyebrow as a large danger counter rather than a small label */
  emphasis?: 'danger' | 'default';
}
export function ArticleSection({
  section,
  emphasis = 'default'
}: ArticleSectionProps) {
  const headingId = `${section.id}-heading`;
  return <section className="px-5 py-10 sm:px-8 md:py-14" aria-labelledby={headingId} data-id="element-19" data-mp="1oo9ubs2xlh22">
      <div className="mx-auto max-w-[42rem]" data-id="element-20" data-mp="1sotrgvni8ko7">
        {section.eyebrow && (emphasis === 'danger' ? <p className="flex items-center gap-3 text-[12px] font-bold uppercase tracking-[0.22em] text-brand-600" data-id="element-21" data-mp="1xlskfavfmlkt">
              {section.eyebrow}
              <span className="h-px flex-1 bg-brand-200" aria-hidden="true" data-id="element-22" data-mp="14yzgkjmqx66l" />
            </p> : <p className="text-[12px] font-bold uppercase tracking-[0.22em] text-neutral-400" data-id="element-23" data-mp="19wr471gcy64z">
              {section.eyebrow}
            </p>)}

        <h2 id={headingId} className="mt-3 text-[26px] font-extrabold leading-[1.2] tracking-[-0.02em] text-ink sm:text-[32px]" data-id="element-24" data-mp="2d27nnndm7dx8">
          {section.title}
        </h2>

      </div>

      {section.image && <ArticleFigure image={section.image} className="mx-auto mt-7 max-w-3xl" data-id="element-25" data-mp="1z98c1wgye3uy" />}

      <div className="mx-auto mt-8 max-w-[42rem]" data-id="element-26" data-mp="1u9vmv52m0kp7">
        <Prose blocks={section.blocks} data-id="element-27" data-mp="1uaokngjlbzv7" />
      </div>
    </section>;
}